<script>
import { api } from "@/state/services";
import { money, dateTime } from "./format";

export default {
  data() {
    return {
      loading: true,
      page: 1,
      balance: 0,
      used: 0,
      payments: [],
      totalPayments: 0,
      perPage: 20,
      paymentStatus: {
        pending: { label: "Aguardando", variant: "warning" },
        approved: { label: "Pago", variant: "success" },
        expired: { label: "Expirado", variant: "secondary" },
        canceled: { label: "Cancelado", variant: "danger" },
      },
      callStatus: {
        active: { label: "Em andamento", variant: "success" },
        creating: { label: "Gerando sala", variant: "warning" },
        finished: { label: "Encerrada", variant: "secondary" },
        unrealized: { label: "Não realizada", variant: "warning" },
        unused: { label: "Ainda não utilizada", variant: "info" },
      },
    };
  },
  methods: {
    money,
    dateTime,
    getHistory() {
      this.loading = true;

      api
        .get("telemedicina/plantao/historico?page=" + this.page)
        .then((response) => {
          if (response.data.status == "success") {
            const history = response.data.history;
            this.balance = history.balance;
            this.used = history.used;
            this.payments = history.payments;
            this.totalPayments = history.total_payments;
            this.perPage = history.per_page;
          } else {
            this.$toast.error(response.data.message || "Não foi possível carregar, tente novamente.");
          }
        })
        .catch(() => {
          this.$toast.error("Não foi possível carregar, tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    status(map, key) {
      return map[key] || { label: key, variant: "secondary" };
    },
  },
  watch: {
    page() {
      this.getHistory();
    },
  },
  mounted() {
    this.getHistory();
  },
};
</script>

<template>
  <div>
    <div class="row mb-4">
      <div class="col-sm-6">
        <div class="card border shadow-none mb-3 mb-sm-0">
          <div class="card-body d-flex align-items-center">
            <div class="plantao-total-icon plantao-total-available mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
              </svg>
            </div>
            <div>
              <div class="text-muted font-size-13 text-uppercase">Créditos disponíveis</div>
              <h3 class="mb-0">{{ balance }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card border shadow-none mb-0">
          <div class="card-body d-flex align-items-center">
            <div class="plantao-total-icon plantao-total-used mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="M18 10.5V7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"></path>
              </svg>
            </div>
            <div>
              <div class="text-muted font-size-13 text-uppercase">Créditos utilizados</div>
              <h3 class="mb-0">{{ used }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-4">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="payments.length == 0" class="text-center text-muted py-4">
          Você ainda não possui pagamentos.
        </div>

        <div v-else>
          <div class="table-responsive d-none d-md-block mb-3">
            <table class="table table-sm table-centered table-history mb-0">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Valor</th>
                  <th>Pagamento</th>
                  <th>Consulta</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in payments" :key="payment.id">
                  <td>
                    {{ dateTime(payment.date) }}
                    <div v-if="payment.date_approved" class="text-muted font-size-12">Pago em {{ dateTime(payment.date_approved) }}</div>
                  </td>
                  <td>{{ money(payment.value) }}</td>
                  <td>
                    <span class="badge text-uppercase" :class="'badge-' + status(paymentStatus, payment.status).variant">{{ status(paymentStatus, payment.status).label }}</span>
                  </td>
                  <td>
                    <template v-if="payment.call">
                      <span class="badge text-uppercase" :class="'badge-' + status(callStatus, payment.call.status).variant">{{ status(callStatus, payment.call.status).label }}</span>
                      <div v-if="payment.call.date" class="text-muted font-size-12">{{ dateTime(payment.call.date) }}</div>
                    </template>
                    <span v-else class="text-muted">–</span>
                  </td>
                  <td class="text-right">
                    <button v-if="payment.call && payment.call.status == 'active'" class="btn btn-sm btn-default" @click="$emit('go-access')">Ir para a consulta</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-md-none mb-3">
            <div v-for="payment in payments" :key="payment.id" class="card border shadow-none mb-2">
              <div class="card-body p-3">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <strong>{{ money(payment.value) }}</strong><br />
                    <small class="text-muted">{{ dateTime(payment.date) }}</small>
                  </div>
                  <span class="badge text-uppercase" :class="'badge-' + status(paymentStatus, payment.status).variant">{{ status(paymentStatus, payment.status).label }}</span>
                </div>
                <div v-if="payment.call" class="d-flex justify-content-between align-items-center border-top mt-2 pt-2">
                  <small class="text-muted">Consulta</small>
                  <span class="badge text-uppercase" :class="'badge-' + status(callStatus, payment.call.status).variant">{{ status(callStatus, payment.call.status).label }}</span>
                </div>
                <button v-if="payment.call && payment.call.status == 'active'" class="btn btn-sm btn-default btn-block mt-2" @click="$emit('go-access')">Ir para a consulta</button>
              </div>
            </div>
          </div>

          <b-pagination
            v-if="totalPayments > perPage"
            v-model="page"
            :total-rows="totalPayments"
            :per-page="perPage"
            align="center"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Altura padrão das linhas: não muda conforme o conteúdo (ex.: pagamento cancelado, sem consulta) */
.table-history tbody td {
  height: 62px;
  vertical-align: middle;
}
/* Badges alinhados ao centro da linha, iguais em todos os status */
.table-history tbody td .badge {
  display: inline-block;
  vertical-align: middle;
  line-height: 1.2;
  margin: 0;
}
.plantao-total-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plantao-total-available {
  background: rgba(53, 195, 147, 0.12);
  color: rgb(53, 195, 147);
}
.plantao-total-used {
  background: rgba(52, 58, 64, 0.08);
  color: #343a40;
}
</style>
